var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20414)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_20414",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42699 14.526C5.56556 14.5072 3.78756 13.7509 2.48294 12.4231C1.17831 11.0952 0.45355 9.30412 0.467608 7.44264C0.481666 5.58117 1.23339 3.80125 2.55792 2.49323C3.88246 1.18522 5.67167 0.455887 7.53318 0.465191C9.39468 0.474494 11.1765 1.22167 12.4879 2.54286C13.7993 3.86405 14.5332 5.65139 14.5286 7.51292C14.5241 9.37444 13.7815 11.1582 12.4636 12.4729C11.1458 13.7877 9.36034 14.5262 7.49881 14.5264",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_20414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.678 1.26591C14.678 0.742181 14.2558 0.320898 13.732 0.320898H1.26521C1.14102 0.320598 1.018 0.344837 0.903212 0.392222C0.788422 0.439608 0.684126 0.509205 0.596313 0.597017C0.508501 0.68483 0.438903 0.789126 0.391517 0.903915C0.344132 1.01871 0.319893 1.14173 0.320193 1.26591L0.320193 13.7327C0.320193 14.2565 0.741476 14.6787 1.26521 14.6787H13.732C14.2558 14.6787 14.678 14.2565 14.678 13.7327V1.26591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2652 0.320508C0.741473 0.320508 0.32019 0.752349 0.32019 1.28802L0.32019 5.10645L14.678 5.10645V1.28802C14.678 0.752349 14.2558 0.320508 13.732 0.320508L1.2652 0.320508Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7331 14.6787C14.2568 14.6787 14.6781 14.2468 14.6781 13.7112V9.89277H0.320313L0.320313 13.7112C0.320312 14.2468 0.742522 14.6787 1.26628 14.6787H13.7331Z",
    fill: "#356BA0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDutch);
export default __webpack_public_path__ + "static/media/menuDutch.99bbca3ab455f32cb89252396b105d65.svg";
export { ForwardRef as ReactComponent };